export default __webpack_public_path__ + "static/media/transactionComplete.0135a723.svg";